export const AUTHENTIFICATION_IMPLEMENTATION = {
  CIAM: "ciam",
  OKTA: "okta"
};

export const seamlessEnvironments = {
  sandbox: {
    tokenValidationUrl: "https://secureidentity-uat.schneider-electric.com/identity/services/apexrest/custom/userinfo"
  },
  prod: {
    tokenValidationUrl: "https://secureidentity.schneider-electric.com/identity/services/apexrest/custom/userinfo"
  }
};

// export const okta_base_url = process.env.REACT_APP_OKTA_URL;

// export const api_base_url = process.env.REACT_APP_API_URL;

// export const front_base_url = process.env.REACT_APP_STORAGE_URL ? process.env.REACT_APP_STORAGE_URL : "";

export const WIDGET_WRAPPER_ADDTO = {
  CART: "cart",
  LIST: "list"
};
